import React, { useState, useEffect, useRef } from 'react'
import './index.less'
// import JSBridge from '@xpeng/js-bridge'
import PrizeDialog from '../../components/prize-dialog'
import Toast from '../../../../components/toast'
import SharePanel from '../../../../components/share-panel'
import { goToPage, defineSelfShareAction } from '../../utils'
import {
  callbackData,
  closeWindow,
  getParamsFromHash,
  goBackV2,
  navHide
} from '../../../../utils/common'
import { DEFAULT_ERROR_MSG } from '../../config'
import {
  GetHomePageConfig,
  GetHomePageConfigAll,
  GetAward
} from '../../api'
import {
  getCurrentUid
} from '../../../../api/web-h5-common'
import {
  AwardActivityItem,
  CumulateActivityItem,
  ModuleItem,
  PageData
} from '../types'
import { trackGdp } from '../../../../utils/gio-report';
import OpenBar from '../../../../components/open-bar'

const ImageModule = ({
  imgUrl,
  jumpUrl
}: {
  imgUrl: string,
  jumpUrl: string
}) => {
  const jump = () => {
    if (jumpUrl) {
      goToPage(jumpUrl)
    }
  }
  return (
    <div className='image-module'>
      <img className='image' src={imgUrl} alt='' onClick={jump} />
    </div>
  )
}

const CumulateActivityModule = ({
  moduleId,
  cumulateActivityList,
  bgImgUrl,
  fetchPrizeByCumulate
}: {
  moduleId: string
  cumulateActivityList: CumulateActivityItem[],
  bgImgUrl: string,
  fetchPrizeByCumulate: (...args) => void
}) => {
  /**
   * 根据累计活动类型返回活动需要的配置信息，包括节点名称、单位
   * 后续若新增累计活动类型，在此维护配置即可（长期方案应该后台api给出）
   * @param count
   * @returns
   */
  const _activityInfo = (activityType: string, count?: number) => {
    const map = {
      'CC': {
        nodeName: `第${count}单`,
        unit: '单'
      },
      'CP': {
        nodeName: `${count}度`,
        unit: '度'
      }
    }
    return map[activityType]
  }

  const _prizeStatusMap = (cumulaDetail: any, prizeItem: any) => {
    // achieveFlag: 0-未达成 1-已达成
    // claimedFlag: 0-未知 1-未领取 2-已领取 10-查看
    const prizeStatusText = {
      0: '', // 未知
      1: '待领取',
      2: '已领取',
      10: '查看'
    }
    if (cumulaDetail?.achieveFlag) {
      if (cumulaDetail?.claimedFlag === 2) {
        return {
          status: '',
          text: prizeStatusText[cumulaDetail?.claimedFlag]
        }
      } else {
        return {
          status: `achieved${prizeItem?.prizeType === 4 ? '-special' : ''}`,
          text: prizeStatusText[cumulaDetail?.claimedFlag]
        }
      }
    } else {
      return {
        status: `unachieved${prizeItem?.prizeType === 4 ? '-special' : ''}`,
        text: '未达成' // 元素占位，实际不显示
      }
    }
  }

  const _prizeBoxMap = (cumulaDetail: any, prizeItem: any, activityCode: string) => {
    let prizeBoxClassName = ''

    if (cumulaDetail?.achieveFlag) {
      if (cumulaDetail?.claimedFlag === 2) {
        prizeBoxClassName = ''
      } else {
        prizeBoxClassName = 'achieved'
      }
    } else {
      if (prizeItem?.prizeType === 4) {
        prizeBoxClassName = 'unachieved-special'
      } else {
        prizeBoxClassName = 'unachieved'
      }
    }

    const clickFn = async () => {
      try {
        await fetchPrizeByCumulate(cumulaDetail?.achieveFlag, cumulaDetail?.claimedFlag === 2, moduleId, activityCode, prizeItem)
      } catch (error) {
        console.log('fetchPrizeByCumulate clickFn error -->', error)
      }
    }

    return {
      prizeBoxClassName,
      clickFn
    }
  }

  /**
   * 获取奖品对应的累计参与信息，由于累计参与信息数组长度可能比奖品数组长，这里需要根据sequence匹配
   * @param cumulaDetailList
   * @param sequence
   */
  const _getCumulaDetail = (cumulaDetailList: any[], sequence: string) => {
    return cumulaDetailList?.find((item: any) => item?.sequence === sequence)
  }

  /**
   * 计算当前累计进度条宽度倍数
   * 若累计进度大于上一节点小于下一节点，则停留在两个节点正中间
   * @param cumulaAmt
   * @param prizeList
   */
  const _curProgressBarWidthRatio = (cumulaAmt: number, prizeList: any[]) => {
    let ratio = 0
    if (prizeList?.length) {
      const largerNodeIndex = prizeList.findIndex((item: any) => item.achieveThreshold > cumulaAmt)
      if (largerNodeIndex === -1) {
        ratio = prizeList.length - 1
      } else {
        const baseRatio = largerNodeIndex - 1
        if (cumulaAmt > prizeList?.[largerNodeIndex - 1]?.achieveThreshold) {
          ratio = baseRatio + 0.5
        } else {
          ratio = baseRatio
        }
      }
    }
    return ratio
  }

  const goToDetailPage = (activityCode: string) => {
    const { origin, pathname } = window.location
    console.log('goToDetailPage', origin, pathname)
    goToPage(`${origin}${pathname}#/detail?activityCode=${activityCode}`)
  }

  return (
    <div className={`cumulative-activity-module ${!bgImgUrl ? 'no-bg' : ''} ${cumulateActivityList?.length === 1 ? 'bg-cover' : ''}`} style={bgImgUrl ? { backgroundImage: `url(${bgImgUrl})` } : {}}>
      <div className='content'>
        {
          !!cumulateActivityList?.length && cumulateActivityList.map((item, index) => (
            <div className='activity-item' key={index}>
              <div className='title-row' onClick={() => goToDetailPage(item?.activityCode)}>
                <span className='title'>{item?.title}</span>
                <span className='detail'>
                  <span className='text'>活动详情</span>
                  <img className='icon' alt='' src={require('../../assets/icon_right_grey.png')}></img>
                </span>
              </div>
              <div className='sub-title'>{item?.subTitle}</div>
              <div className='node-bar'>
                <div className='x-scroll-wrapper'>
                  <div className={`prize-and-desc-nodes ${item?.prizeList?.length === 2 ? 'two-nodes' : ''}`}>
                    {
                      item?.prizeList?.length && item?.prizeList.map((prizeItem, prizeIndex) => (
                        <div className='node' key={prizeIndex}>
                          <div
                            className='prize-wrapper'
                            onClick={_prizeBoxMap(_getCumulaDetail(item?.cumulaDetailList, prizeItem?.sequence), prizeItem, item?.activityCode).clickFn}
                          >
                            <div
                              className={`status ${_prizeStatusMap(_getCumulaDetail(item?.cumulaDetailList, prizeItem?.sequence), prizeItem).status}`}
                            >
                              {_prizeStatusMap(_getCumulaDetail(item?.cumulaDetailList, prizeItem?.sequence), prizeItem).text}
                            </div>
                            <div
                              className={`prize ${_prizeBoxMap(_getCumulaDetail(item?.cumulaDetailList, prizeItem?.sequence), prizeItem, item?.activityCode).prizeBoxClassName}`}
                            >
                              <img alt='' className='prize-img' src={prizeItem?.picture} />
                              {prizeItem?.prizeValue && <div className={`count ${_prizeBoxMap(_getCumulaDetail(item?.cumulaDetailList, prizeItem?.sequence), prizeItem, item?.activityCode).prizeBoxClassName}`}>{prizeItem?.prizeValue}</div>}
                            </div>
                          </div>
                          <div className='progress-bar-node'>
                            <div className={`round ${_getCumulaDetail(item?.cumulaDetailList, prizeItem?.sequence)?.achieveFlag ? 'achieved' : ''}`}></div>
                            {
                              prizeIndex !== item?.prizeList?.length - 1 && (
                                <div className={`bar ${item?.prizeList?.length === 2 ? 'two-nodes' : item?.prizeList?.length === 3 ? 'three-nodes' : ''}`}></div>
                              )
                            }
                          </div>
                          <div className='desc'>{_activityInfo(item?.activityType, prizeItem?.achieveThreshold)?.nodeName}</div>
                        </div>
                      ))
                    }
                  </div>
                  {
                    (!!item?.cumulaDetailList.length && item?.cumulaAmt > 0) && (
                      <div
                        className={`current-progress ${item?.prizeList?.length === 2 ? 'two-nodes' : item?.prizeList?.length === 3 ? 'three-nodes' : ''}`}
                        style={{ "--width-ratio": _curProgressBarWidthRatio(item?.cumulaAmt, item?.prizeList) } as React.CSSProperties}
                      >
                        <img src={require('../../assets/current-node.png')} alt='' className='current-node' />
                      </div>
                    )
                  }
                </div>
                <div className='right-modal'></div>
              </div>
              {
                item?.cumulaAmt >= item?.prizeList?.[item?.prizeList?.length - 1]?.achieveThreshold ? (
                  <div className='cumulaAmt achieved'>
                    <img src={require('../../assets/success.png')} alt='' className='achieved-icon' />
                    <span className='desc'>已全部达成</span>
                  </div>
                ) : (
                  <div className='cumulaAmt unachieved'>已累计<span className='num'>{item?.cumulaAmt || 0}</span><span className='unit'>{_activityInfo(item?.activityType)?.unit}</span></div>
                )
              }
            </div>
          ))
        }
      </div>
    </div>
  )
}

const AwardActivityModule = ({
  moduleId,
  awardActivityList,
  bgImgUrl,
  fetchPrizeByAward
}: {
  moduleId: string,
  awardActivityList: AwardActivityItem[],
  bgImgUrl: string,
  fetchPrizeByAward: (...args) => void
}) => {
  const [loadingActivityCode, setLoadingActivityCode] = useState('')
  const handleFetchPrize = async (gain, activityCode) => {
    if (loadingActivityCode) return
    setLoadingActivityCode(activityCode)
    try {
      await fetchPrizeByAward(gain, moduleId, activityCode)
    } catch (error) {
      console.log('handleFetchPrize error -->', error)
    } finally {
      setLoadingActivityCode('')
    }
  }
  return (
    <div className={`award-receiving-module ${!bgImgUrl ? 'no-bg' : ''} ${awardActivityList?.length === 1 ? 'bg-cover' : ''}`} style={bgImgUrl ? { backgroundImage: `url(${bgImgUrl})` } : {}}>
      {
        !!awardActivityList?.length && awardActivityList.map((item, index) => (
          <img
            alt=''
            className={`image ${loadingActivityCode === item.activityCode ? 'activity-loading' : ''}`}
            key={index}
            src={item.gain ? item?.canNotClaimedPic : item?.picture}
            onClick={() => handleFetchPrize(item?.gain, item?.activityCode)}
          />
        ))
      }
    </div>
  )
}

const Module = ({
  moduleType,
  moduleItem,
  fetchPrizeFn
}: {
  moduleType: number,
  moduleItem: ModuleItem,
  fetchPrizeFn: {
    'cumulate': (...args) => void,
    'award': (...args) => void,
  }
}) => {
  const _moduleMap = {
    1: <ImageModule imgUrl={moduleItem?.bgImgUrl} jumpUrl={moduleItem?.jumpUrl} />,
    2: <AwardActivityModule
      moduleId={moduleItem?.moduleId}
      awardActivityList={moduleItem?.awardActivityList}
      bgImgUrl={moduleItem?.bgImgUrl}
      fetchPrizeByAward={fetchPrizeFn.award}
    />,
    3: <CumulateActivityModule
      moduleId={moduleItem?.moduleId}
      cumulateActivityList={moduleItem?.cumulateActivityList}
      bgImgUrl={moduleItem?.bgImgUrl}
      fetchPrizeByCumulate={fetchPrizeFn.cumulate}
    />
  }
  return _moduleMap[moduleType]
}

const App = () => {
  const UA = navigator.userAgent || '';
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const pageId = getParamsFromHash('pageId') || ''
  const versionId = getParamsFromHash('versionId') || ''
  const queryType = getParamsFromHash('queryType') || ''
  const uid = useRef('')

  const shareInfo = {
    shareMainTitle: '点击领取福利！',
    shareSubTitle: '来福利中心，多重福利免费领。更多超值充电活动，快来参与！',
    shareImgUrl: require('../../assets/welfare-share.jpg')
  }
  const [showSharePanel, setShowSharePanel] = useState(false)
  const [showPrizeDialog, setShowPrizeDialog] = useState(false)
  const [pageData, setPageData] = useState<PageData>()
  const [prizeDialogInfo, setPrizeDialogInfo] = useState({
    iconUrl: '',
    title: '',
    subTitle: '',
    showBg: true,
    showButton: true,
    buttonText: '知道了'
  })

  useEffect(() => {
    document.title = '充电福利专区'
    // 小鹏APP内webview全屏
    navHide()
    getCurrentUid().then(userId => {
      uid.current = userId
      getPageData(queryType)
    }).catch(err => {
      console.log('getCurrentUid error-->', err)
    })
    callbackData({
      reflashActivityData: true
    })
  }, [])

  const callShare = () => {

    try {
      setShowSharePanel(true)
    } catch (error) {
      console.log('callShare error-->', error)
    }
  }

  const getPageData = async (type: string, init = true) => {
    const request = type === 'all' ? GetHomePageConfigAll : GetHomePageConfig
    try {
      const res: any = await request({ pageId, versionId })
      if (res.code === 200) {
        const moduleList = res?.data?.moduleList || []

        // 累计活动模块的奖品节点需要和参与进度节点匹配
        // 若当前没有参与进度，服务端直接返回null，进度条展示状态会出错，这里前端做一下未达成的兜底数据
        moduleList.length > 0 && moduleList.forEach((module: ModuleItem) => {
          const cumulateActivityList = module?.cumulateActivityList ?
            JSON.parse(JSON.stringify(module?.cumulateActivityList)) : []
          if (cumulateActivityList?.length > 0) {
            cumulateActivityList.forEach((item: CumulateActivityItem) => {
              if ((!item?.cumulaDetailList || item?.cumulaDetailList?.length === 0) && item?.prizeList?.length > 0) {
                item.cumulaDetailList = []
                item?.prizeList.forEach((prize: any) => {
                  item.cumulaDetailList.push({
                    achieveFlag: 0, // 0--未达成 1--已达成
                    claimedFlag: 1, // 0--未知 1--未领取 2--已领取 10--查看
                    sequence: prize.sequence
                  })
                })
              }
            })
            module.cumulateActivityList = cumulateActivityList
          }
        })

        setPageData(res?.data)

        if (init) {
          setTimeout(() => {
            scrollAction()
          }, 0)
        }

        // 上报埋点
        let moduleIds: string[] = []
        let activityIds: string[] = []
        moduleList.length > 0 && moduleList.forEach((module: ModuleItem) => {
          moduleIds.push(module?.moduleId)
          if (module?.awardActivityList?.length > 0) {
            module?.awardActivityList.forEach(item => {
              activityIds.push(item?.activityCode)
            })
          }
          if (module?.cumulateActivityList?.length > 0) {
            module?.cumulateActivityList.forEach(item => {
              activityIds.push(item?.activityCode)
            })
          }
        })
        trackGdp('P11245', 'B001', {
          moduleIds: moduleIds.join(','),
          activityIds: activityIds.join(','),
          pageId: res?.data?.pageId,
          versionId: res?.data?.versionId
        })
      } else {
        showToast(DEFAULT_ERROR_MSG)
      }
    } catch (error) {
      showToast(DEFAULT_ERROR_MSG)
      console.log('getPageData error -->', error)
    }
  }

  /**
   * 累计活动节点条，若首个待领取/未达成的节点不在首屏内，滚动到首屏最后一个，此方法依赖元素类名，若类名变更，需要修改此方法
   */
  const scrollAction = () => {
    const cumulateModuleDom = document.getElementsByClassName('cumulative-activity-module')
    const cumulateDomChildNodes = Array.from(cumulateModuleDom)
    if (cumulateDomChildNodes?.length > 0) {
      cumulateDomChildNodes.forEach(dom => {
        const activityItemNodes: any = dom?.childNodes?.[0]?.childNodes
        if (activityItemNodes?.length > 0) {
          activityItemNodes.forEach((activityItem: any) => {
            const xScrollWrapper = activityItem?.getElementsByClassName('x-scroll-wrapper')[0]
            const prizeNodes = Array.from(xScrollWrapper?.getElementsByClassName('node'))
            if (prizeNodes?.length > 0) {
              const achievedNode: any = prizeNodes.find((node: any) => node.getElementsByClassName('status achieved').length > 0)
              const unAchievedNode: any = prizeNodes.find((node: any) => node.getElementsByClassName('status unachieved').length > 0)
              const targetNode = achievedNode || unAchievedNode
              const targetNodeIndex = prizeNodes.indexOf(targetNode)
              if (targetNode && targetNode.getBoundingClientRect().x > window.innerWidth) {
                console.log('targetNode', targetNode, targetNodeIndex)
                xScrollWrapper.scrollLeft = targetNode?.scrollWidth * (targetNodeIndex - 3 + 0.5)
              }
            }
          })
        }
      })
    }
  }

  const NavBar = ({ callShare }: any) => {
    return (
      <div className={`marketing-nav-bar`}>
        <img src={require('../../assets/back.png')} alt='' className='icon' onClick={goBackV2} />
        <span className={`title`}>充电福利专区</span>
        <img src={require('../../assets/share.png')} alt='' className='icon' onClick={callShare} />
      </div>
    )
  }

  /**
   * 领奖
   * 若当前节点奖品状态为未达成/已领取，不再调用领奖接口，直接展示奖品弹窗，两者展示的样式注意区分
   * 若已达成的当前节点奖品是不可直接领取的特殊奖品，需要跳转到对应url查看
   * @param achieved 当前奖品是否已达成
   * @param gain 当前奖品是否已领取
   * @param moduleId 模块id
   * @param activityId 活动编码
   * @param prizeItem 奖品信息，累计活动模块领奖必填
   */
  const fetchPrizeByCumulate = (achieved: boolean, gain: boolean, moduleId: string, activityId: string, prizeItem?: any) => {
    // 上报埋点
    trackGdp('P11245', 'B002', {
      moduleId,
      activityId,
      pageId: pageData?.pageId,
      versionId: pageData?.versionId
    })
    if (!achieved) {
      setPrizeDialogInfo({
        iconUrl: prizeItem?.picture,
        title: prizeItem?.prizeName,
        subTitle: '',
        showBg: false,
        showButton: false,
        buttonText: ''
      })
      setShowPrizeDialog(true)
      return
    }

    if(prizeItem?.jumpUrl){
      goToPage(prizeItem?.jumpUrl)
      return
    }

    if (gain) {
      setPrizeDialogInfo({
        iconUrl: prizeItem?.canNotClaimedPic,
        title: '已经领取过啦',
        subTitle: prizeItem?.prizeName,
        showBg: true,
        showButton: false,
        buttonText: ''
      })
      setShowPrizeDialog(true)
      return
    }

    // if (prizeItem?.prizeType === 4) {
    //   goToPage(prizeItem?.jumpUrl)
    //   return
    // }

    return doGetAward('cumulate', activityId, prizeItem?.sequence)
  }

  const fetchPrizeByAward = (gain: boolean, moduleId: string, activityId: string) => {
    // 上报埋点
    trackGdp('P11245', 'B002', {
      moduleId,
      activityId,
      pageId: pageData?.pageId,
      versionId: pageData?.versionId
    })
    if (gain) {
      showToast('您已领取，无需重复领取')
      return
    }

    return doGetAward('award', activityId)
  }

  const doGetAward = async (type: string, activityId: string, nodeSequence?: any) => {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const res: any = await GetAward({ source: 1, activityId, nodeSequence, uid: uid.current })
        if (res.code === 200) {
          setPrizeDialogInfo({
            iconUrl: type === 'cumulate' ? res?.data?.showImg : '',
            title: '恭喜您已获得',
            subTitle: '',
            showBg: true,
            showButton: true,
            buttonText: '知道了'
          })
          setShowPrizeDialog(true)
          // 领奖后更新页面状态
          getPageData(queryType, false)
          resolve('success')
        } else {
          showToast(res?.msg)
          reject(res?.msg)
        }
      } catch (error) {
        console.log('GetAward error -->', error)
        reject(error)
      }
    })
  }

  const showToast = (text: string) => {
    Toast.show({
      text,
      duration: 2000
    });
  }

  const fetchPrizeFn = {
    'cumulate': fetchPrizeByCumulate,
    'award': fetchPrizeByAward
  }

  return (
    <div className={`charge-marketing-home ${isXPApp ? 'charge-marketing-home-inapp' : ''}`} style={{ backgroundImage: `url(${pageData?.bgImgUrl})` }}>
      {isXPApp && <NavBar callShare={callShare} />}
      {
        !!pageData?.moduleList?.length && pageData?.moduleList.map((item, index) => (
          <Module key={index} moduleType={item?.moduleType} moduleItem={item} fetchPrizeFn={fetchPrizeFn} />
        ))
      }
      <PrizeDialog
        visible={showPrizeDialog}
        onClose={() => setShowPrizeDialog(false)}
        iconUrl={prizeDialogInfo?.iconUrl}
        title={prizeDialogInfo?.title}
        subTitle={prizeDialogInfo?.subTitle}
        showBg={prizeDialogInfo?.showBg}
        showButton={prizeDialogInfo?.showButton}
        buttonText={prizeDialogInfo?.buttonText}
      />
      <SharePanel
        visible={showSharePanel}
        shareInfo={shareInfo}
        onClose={() => setShowSharePanel(false)}
      />
    </div>
  )
}

export default App
